// extracted by mini-css-extract-plugin
export const padding = "testimonialCard1-module--padding--hqa-m";
export const container = "testimonialCard1-module--container--1edb1";
export const imgContainer = "testimonialCard1-module--imgContainer--edC4l";
export const info = "testimonialCard1-module--info--3uSuZ";